import { render } from "./MobileCurrencySelector.vue?vue&type=template&id=70862457"
import script from "./MobileCurrencySelector.vue?vue&type=script&lang=js"
export * from "./MobileCurrencySelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__